import { useState } from "react";
import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/layout/PageHero";
import { Reveal } from "@/components/layout/Motion";
import { CallCta } from "@/components/layout/CtaBlocks";
import { BLOG } from "@/data/content";

const TAGS = ["All", ...new Set(BLOG.map((b) => b.tag))];

export default function Blog() {
  const [tag, setTag] = useState("All");
  const list = tag === "All" ? BLOG : BLOG.filter((b) => b.tag === tag);
  return (
    <Layout>
      <PageHero testId="blog-hero" compact crumb="Travel journal" line1="Travel journal" text="Stories, tips and slow-travel ideas from our travel specialists." />
      <section className="bg-sand py-14">
        <div className="mx-auto max-w-[1320px] px-4 sm:px-8">
          <div className="flex flex-wrap gap-2" data-testid="blog-tags">
            {TAGS.map((t) => (
              <button key={t} onClick={() => setTag(t)} data-testid={`blog-tag-${t.toLowerCase().replace(/\s/g, "-")}`}
                className={`rounded-full px-4 py-2 text-sm font-bold transition-colors ${tag === t ? "bg-ink text-white" : "bg-white text-ink hover:bg-brand-soft"}`}>{t}</button>
            ))}
          </div>
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((b, i) => (
              <Reveal key={b.title} delay={i * 0.05} className="group overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid={`blog-card-${i}`}>
                <div className="aspect-[16/10] overflow-hidden"><img src={b.image} alt={b.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
                <div className="p-5"><span className="text-[11px] font-extrabold uppercase tracking-wide text-brand">{b.tag}</span><h3 className="mt-2 font-display text-lg font-bold text-ink">{b.title}</h3><p className="mt-2 text-sm text-slate-600">{b.text}</p></div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CallCta />
    </Layout>
  );
}
